import { Icon } from '@/components/Icon'
import type { SidebarLogoProps } from './types'
import type { FC } from 'react'
import { Box, Stack } from '@mui/material'
import { styles } from './styles'

export const SidebarLogo: FC<SidebarLogoProps> = (props) => {
  const { collapse } = props

  return (
    <Stack sx={styles.root}>
      <Box className={!collapse ? 'logo' : 'logo-collapse'}>
        <Icon section="general" name="logo" iconStyles="iconSize" />
      </Box>
      <Box className={!collapse ? 'title' : 'title-collapse'}>
        <Icon section="general" name="logo-title" iconStyles="iconSize" />
      </Box>
    </Stack>
  )
}
